import { createFileRoute } from "@tanstack/react-router";

import { Tokens } from "@/features/publisher";

export const Route = createFileRoute("/publisher/tokens")({
  component: Tokens,
});
